import React from 'react';
import PropTypes from 'prop-types';

const Skills = ({ color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        // eslint-disable-next-line max-len
        d="M18 8.75494C18 5.58592 15.304 3 12 3C8.69604 3 6 5.58592 6 8.75494C6 9.21128 6.05287 9.66761 6.18503 10.1239C6.34362 10.8592 6.63437 11.3155 7.03084 11.9493C7.11014 12.1014 7.21586 12.2535 7.32159 12.431C7.45374 12.6338 7.55948 12.8366 7.69164 13.0141C8.22027 13.8507 8.53745 14.3324 8.53745 15.3211V17.7042C8.53745 18.3127 8.98679 18.7944 9.59472 18.8958C9.85904 20.1888 10.652 21 12 21C13.348 21 14.1674 20.1888 14.4053 18.8958C15.0132 18.7944 15.4625 18.2873 15.4625 17.7042V15.3211C15.4625 14.3324 15.7797 13.8254 16.3084 13.0141C16.4141 12.8366 16.5463 12.6338 16.6784 12.431C16.7841 12.2535 16.8899 12.1014 16.9692 11.9493C17.3656 11.3155 17.6564 10.8592 17.815 10.1239C17.9471 9.66761 18 9.21128 18 8.75494ZM14.4317 15.9296H9.62115V15.3465C9.62115 15.2197 9.62115 15.1183 9.59472 15.0169H14.4317C14.4317 15.1183 14.4053 15.2197 14.4053 15.3465V15.9296H14.4317ZM14.1938 17.9324H9.80617C9.67401 17.9324 9.59472 17.831 9.59472 17.7296V16.9437H14.4053V17.7296C14.4317 17.831 14.326 17.9324 14.1938 17.9324ZM12 20.0113C11.7093 20.0113 10.9692 20.0113 10.6784 18.9465H13.348C13.0573 20.0113 12.2907 20.0113 12 20.0113ZM16.7841 9.92113C16.652 10.4789 16.4405 10.8592 16.0705 11.4423C15.9648 11.5944 15.8855 11.7465 15.7797 11.924C15.6476 12.1268 15.5418 12.3296 15.4361 12.4817C15.1189 12.9887 14.8282 13.4451 14.6432 13.9775H9.4097C9.22467 13.4451 8.96036 12.9887 8.61674 12.4817C8.51102 12.3042 8.37886 12.1268 8.27314 11.924C8.16741 11.7465 8.06167 11.569 7.98238 11.4423C7.61233 10.8338 7.40088 10.4789 7.26872 9.89578C7.16299 9.5155 7.11013 9.13522 7.11013 8.75494C7.11013 6.14367 9.3304 4.01409 12.0529 4.01409C14.7753 4.01409 16.9956 6.14367 16.9956 8.75494C16.9427 9.13522 16.8899 9.5155 16.7841 9.92113Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
      />
    </svg>
  );
};

Skills.propTypes = {
  color: PropTypes.string,
};
export default Skills;
